import React from "react";

const Info = ({ className }) => {
  return (
    <div>
      {/* <svg
        className={className}
        dataSlot="icon"
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true">
        <path clipRule="evenodd" fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
      </svg> */}
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 5.5C11 6.95869 10.4205 8.35764 9.38909 9.38909C8.35764 10.4205 6.95869 11 5.5 11C4.04131 11 2.64236 10.4205 1.61091 9.38909C0.579463 8.35764 0 6.95869 0 5.5C0 4.04131 0.579463 2.64236 1.61091 1.61091C2.64236 0.579463 4.04131 0 5.5 0C6.95869 0 8.35764 0.579463 9.38909 1.61091C10.4205 2.64236 11 4.04131 11 5.5ZM6.1875 2.75C6.1875 2.93234 6.11507 3.1072 5.98614 3.23614C5.8572 3.36507 5.68234 3.4375 5.5 3.4375C5.31766 3.4375 5.1428 3.36507 5.01386 3.23614C4.88493 3.1072 4.8125 2.93234 4.8125 2.75C4.8125 2.56766 4.88493 2.3928 5.01386 2.26386C5.1428 2.13493 5.31766 2.0625 5.5 2.0625C5.68234 2.0625 5.8572 2.13493 5.98614 2.26386C6.11507 2.3928 6.1875 2.56766 6.1875 2.75ZM4.8125 4.8125C4.63016 4.8125 4.4553 4.88493 4.32636 5.01386C4.19743 5.1428 4.125 5.31766 4.125 5.5C4.125 5.68234 4.19743 5.8572 4.32636 5.98614C4.4553 6.11507 4.63016 6.1875 4.8125 6.1875V8.25C4.8125 8.43234 4.88493 8.6072 5.01386 8.73614C5.1428 8.86507 5.31766 8.9375 5.5 8.9375H6.1875C6.36984 8.9375 6.5447 8.86507 6.67364 8.73614C6.80257 8.6072 6.875 8.43234 6.875 8.25C6.875 8.06766 6.80257 7.8928 6.67364 7.76386C6.5447 7.63493 6.36984 7.5625 6.1875 7.5625V5.5C6.1875 5.31766 6.11507 5.1428 5.98614 5.01386C5.8572 4.88493 5.68234 4.8125 5.5 4.8125H4.8125Z"
          fill="#fbbf24"
        />
      </svg>
    </div>
  );
};

export default Info;
